import { trigger, animate, style, group, query, transition, stagger } from '@angular/animations';

export const fadeInUp = trigger('fadeInUp', [
    transition(':enter', [
        query('.animate-fadeinup', [
            style({ opacity: 0, transform: 'translateY(18px)' }),
            stagger(10, [
                animate('250ms ease-out', style({ opacity: 1, transform: 'none' })),
            ]),
        ], {optional: true})
    ]),
])


// WEBPACK FOOTER //
// ./src/app/services/animations/fadeInUp.animation.ts